import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, Grid, Grow, TextField } from "@material-ui/core";
import MainBox from "../Items/MainBox";
import TextFieldComponent from "components/TextField";
import SelectOption from "../Items/SelectOption";
import AddActivity from "../Items/AddActivity";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { toast } from "react-toastify";
import ActivitesList from "../Items/ActivitesList";
import StepDesc from "../Items/StepDesc";

const ROLES = ["سرگروه", "روایت و محتوا" ,"اجرا و فضاسازی" ,"رسانه و مستند سازی" ];

export default function CreationENGH(props) {
  const { states, setStates } = props;
  const [coop, setCoop] = useState({});

  const [role, setRole] = useState(0);
  const isCurrentUserLeader = () => {
    // console.log("USERRRR", props.creator.user_id);
    if (!props.isGroupCreated) {
      // If the group is not created, the creator is the leader
      return true;
    }
    if (Array.isArray(props.createdGroup?.members)) {
      const leader = props.createdGroup.members.find(
        (member) => member.role === "سرگروه"
      );
      return leader?.user_id === props.creator.user_id;
    }
    return false;
  };
  const isLeader = isCurrentUserLeader();
  // console.log(isLeader);
  const addMemberHandler = () => {
    if (!coop?.user_id) {
      return toast.error("یک شخص را انتخاب کنید!", { toastId: 20 });
    }
    if (role === 0) {
      return toast.error("یک نقش انتخاب کنید!", { toastId: 21 });
    }
    if (states.memberList.length > 0) {
      // console.log(role, states);
      if (role === 1 && states.memberList.find((item) => item.role === 1)) {
        return toast.error("شما میتوانید فقط یک سرگروه داشته باشید", {
          toastId: 1,
        });
      }

      if (states.memberList.find((m) => m.user_id === coop.user_id)) {
        return toast.error("این شخص در لیست حضور دارد!");
      }
    }
    const newMember = {
      slug: coop.user_slug,
      name: coop.user_full_name,
      user_id: coop.user_id,
      role_id: role,
      role: ROLES[role - 1],
    };
    setStates({
      ...states,
      memberList: [...states.memberList, newMember],
    });
  };
  // console.log(
  //   props?.isGroupCreated,
  //   props?.createdGroup,
  //   Array.isArray(props?.createdGroup?.members),
  //   props?.createdGroup?.members
  // );

  // useEffect(() => {
  //   console.log("@@@@@@@@@@");
  //   // props?.createdGroup?.members?.find(m =));
  // }, [props?.createdGroup]);
  const isAdmin = () => {
    // if (props?.isGroupCreated && Array.isArray(props?.createdGroup?.members) )
  };
  return (
    <MainBox>
      <StepDesc>
        تو این مرحله باید کسایی که باهم دیگه مدرسه انقلابتون رو برگزار کردید
        اضافه کنید. دقت کنید که هرکس تو این مرحله به گروهتون اضافه بشه میتونه به
        این گزارش تو عقیق خودش دسترسی داشته باشه و کنار شما فعالیت هاشو تو هر
        مرحله ثبت کنه.ما لیست بچه های انجمنی مدرستون رو براتون آماده کردیم. فقط
        کافیه انتخاب کنید و گروهی که همکاری کردن رو هم مشخص کنید.اگر کسی از بچه
        های انجمن هست که اسمش تو لیست نیست به مربی یا مسئول شهرستانتون اطلاع
        بدید که اسمش رو تو سامانه اضافه کنه.
      </StepDesc>
      <div className="memberAdder">
        <div
          className={`flexRow groupNameContainer`}
          style={{
            width: "50%",
          }}
        >
          <label>نام گروه را وارد کنید<span style={{color:'red'}}>*</span></label>
          <input
            type="text"
            className="groupNameTextField"
            style={{ marginRight: 10 }}
            placeholder="نام گروه"
            value={states.groupName}
            onChange={(e) => {
              setStates({ ...states, groupName: e.target.value });
            }}
          />
          {/* // <TextFieldComponent */}
        </div>
        <div className={`flexRow memberAddContainer`}>
          <label>انتخاب اعضای گروه</label>
          {/* <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          /> */}
          <Autocomplete
            // value={role}
            // className={classes.autoComplete}
            onChange={(event, newValue) => {
              //   setRole(newValue);
              console.log(newValue);
              setCoop(newValue);
            }}
            className="creationAutoComplete"
            // inputValue={roleInputValue}
            // onInputChange={(event, newInputValue) => {
            //     setRoleInputValue(newInputValue);
            // }}

            noOptionsText="وجود ندارد"
            options={props?.coops}
            getOptionLabel={(option) =>
              option.user_full_name ? `${option.user_full_name}` : ""
            }
            renderOption={(option) => (
              <Grid container alignItems="center" wrap="nowrap">
                <span>{option.user_full_name}</span>
              </Grid>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                // className={classes.TextField}
                placeholder="انتخاب اعضا"
                inputProps={{
                  ...params.inputProps,
                  autoCorrect: "off",
                  spellCheck: false,
                  // onCopy={(e) => e.preventDefault()}
                  // onPaste={(e) => e.preventDefault()}
                  autoComplete: "off",
                  // autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <label style={{ marginLeft: 15 }}> در نقش</label>
          <SelectOption
            items={[
              // { title: "سرگروه", id: 1 },
              { title: "روایت و محتوا", id: 2 },
              { title: "اجرا و فضاسازی", id: 3 },
              { title: "تیم  رسانه و مستند سازی", id: 4 },
            ]}
            stateId={role}
            setStateID={setRole}
          />
          {/* <select>
            <option>سرگروه</option>
            <option>تیم اجرایی</option>
            <option>تیم رسانه</option>
            <option>تیم محتوا</option>
          </select> */}
          <Button
            variant="text"
            className="addMemberButton"
            onClick={addMemberHandler}
          >
            <AddCircleOutlineIcon
              className="addIconMember"
              style={{ color: "#189db3" }}
            />
            <p>افزودن</p>
          </Button>
        </div>
        <div style={{ marginBottom: 20 }}>
          <span>
            <strong>توجه</strong>: سازنده گروه به طور خودکار به عنوان سرگروه ثبت
            می‌شود.
          </span>
        </div>
      </div>
      <div className="CreationTable">
        <h1>اعضا</h1>
        <table>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>نام و نام خانوادگی</th>
              <th>نقش</th>
              <th>اقدامات</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{1}</td>
              <td>{props.creator.name}</td>
              <td>
                {isLeader
                  ? "سرگروه"
                  : props?.createdGroup?.members?.find(
                      (m) => m?.name === props?.creator?.name
                    )?.role}
              </td>
              <td></td>
            </tr>
            {states.memberList.map((item, index) => {
              return (
                <Grow in={true} key={index} timeout={700}>
                  <tr key={index}>
                    <td>{index + 2}</td>
                    <td>{item.name}</td>
                    <td>{item.role}</td>
                    <td>
                      {isLeader && (
                        <Button
                          onClick={() => {
                            setStates({
                              ...states,
                              memberList: states.memberList.filter(
                                (_, i) => i !== index
                              ),
                            });
                          }}
                        >
                          <DeleteForeverIcon style={{ color: "#f26868" }} />
                        </Button>
                      )}
                    </td>
                  </tr>
                </Grow>
              );
            })}
            {/* {states.memberList.length === 0 && (
              <tr>
                <td colSpan="4" style={{ color: "#Ccc" }}>
                  هیچ عضوی وجود ندارد
                </td>
              </tr>
            )} */}
          </tbody>
        </table>
      </div>
      <p>
        توجه: در این بخش میتوانید تصاویر و ویدئو مرتبط با جلسات همفکری تیم، مراحل
آماده سازی و... بارگذاری گردد.
      </p>
      <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        goForRefresh={props.goForRefresh}
      />
      <ActivitesList
        step={1}
        activities={props.activities}
        stepActs={props.stepActs}
        refresh={props.refresh}
      />
    </MainBox>
  );
}
